import { HttpClient } from '../HttpClient';
/**
 * * Get Job Requisition Approvers
 */
export const GetJobRequisitionsApprovers = async (departmentId) => {
  try {
    const { data } = await HttpClient.get('api/jobrequisitions/approvers', {
      params: {
        departmentId: departmentId,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
